import { gql } from '@apollo/client'

// Types
export type TransactionTypeFilter =
  | 'BRIDGE_LOAN'
  | 'HOME_SWAP'
  | 'CORRESPONDENT'
  | 'MORTGAGE_BROKER'
  | 'PURCHASE_OFFER'
  | 'MORTGAGE_ONLY'

export type EligibilityStatusFilter =
  | 'NEEDS_ASSIGNMENT'
  | 'INITIAL_REVIEW'
  | 'READY_FOR_APPROVAL'
  | 'MARKETABILITY_REVIEW'
  | 'UPDATE_ELIGIBILITY'
  | 'MISSING_INFO'
  | 'APPROVED'
  | 'DECLINED'
  | 'NOT_ELIGIBLE'

export type LoanStatusFilter =
  | 'FILE_STARTED'
  | 'PRE_QUALIFIED'
  | 'PRE_APPROVED'
  | 'UNDER_CONTRACT'
  | 'CLEAR_TO_CLOSE'
  | 'FUNDED'

export type CustomerTransactionSortField =
  | 'CREATED'
  | 'CUSTOMER_NAME'
  | 'LISTING_ADDRESS'
  | 'ELIGIBILITY_STATUS'
  | 'LOAN_STATUS'
  | 'AGENT'

export type BackyardCustomerTransaction = {
  transactionId: string
  customerName: string | null
  listingAddress: string | null
  purchaseAddress: string | null
  eligibilityStatus: string | null
  userFriendlyEligibilityStatus: string | null
  loanStatus: string | null
  agent: string | null
  transactionType: string | null
  userFriendlyTransactionType: string | null
  loanNumber: string | null
  loanId: string | null
  programType: string | null
  programEligibility: string | null
  created: string | null
}

export type FilterableCustomerTransactionsResponse = {
  filterableCustomerTransactions: {
    transactions: BackyardCustomerTransaction[]
    pagination: {
      totalCount: number
      limit: number
      offset: number
    }
  }
}

export type FilterableCustomerTransactionsVariables = {
  input: {
    pagination: {
      limit: number
      offset: number
    }
    sort?: {
      field: CustomerTransactionSortField
      direction: 'ASC' | 'DESC'
    }
    filter: {
      transactionType: TransactionTypeFilter
      customerSearch?: string
      addressSearch?: string
      eligibilityStatus?: EligibilityStatusFilter[]
      loanStatus?: LoanStatusFilter[]
    }
  }
}

// Query
export const FILTERABLE_CUSTOMER_TRANSACTIONS = gql`
  query filterableCustomerTransactions($input: FilterableCustomerTransactionsInput!) {
    filterableCustomerTransactions(input: $input) {
      transactions {
        transactionId
        customerName
        listingAddress
        purchaseAddress
        eligibilityStatus
        userFriendlyEligibilityStatus
        loanStatus
        agent
        transactionType
        userFriendlyTransactionType
        loanNumber
        loanId
        programType
        programEligibility
        created
      }
      pagination {
        totalCount
        limit
        offset
      }
    }
  }
`
